var _metadata, _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.3 106.73",
    id: "svg767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata771"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs757"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style755"
  }, ".cls-1{fill:#033580;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 128.52,69.34 c -5.13,-5.23 -42.16,-46.69 -43,-47.61 0.74,1 30.83,43.32 13.71,71.51 0,0 0.92,-49 -42.81,-59.67 L 20.5244,65.867829 c 0,0 -5.609828,7.658799 0.377656,13.358685 L 63.71,128.46 c -3.14,-3.78 -28.63,-36 -13.4,-70.61 0,0 0.37,49 43,59.49 l 34.95583,-36.141028 c 0,0 5.44417,-6.578972 0.25417,-11.858972 z M 75.13,91.46 C 61.217187,91.46891 54.245979,74.649279 64.082629,64.812629 73.919279,54.975979 90.73891,61.947187 90.73,75.86 c 0.0055,8.617932 -6.982068,15.60553 -15.6,15.6 z",
    transform: "translate(-18,-21.73)",
    id: "path759"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.64 45.68 62.64 48.94 59.38 48.94 59.38 62.68 54.88 62.68 54.88 48.94 51.73 48.94 51.73 45.68 62.64 45.68",
    id: "polygon762"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.799c1dc039cee2db373b3b7c83ab62da.svg";
export { ForwardRef as ReactComponent };